import { useTranslation } from '@sib/i18n';

interface DeactivatedUserOptionProps {
  label?: string;
}

export const DeactivatedUserOption = ({
  label = '',
}: DeactivatedUserOptionProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-1">
      {label}
      <span className="font-light lowercase">({t('deactivated')})</span>
    </div>
  );
};
